<script>
  export let wistiaSlug
  export let className;
</script>

<style>
  .more-img {
    cursor: pointer;
    grid-column: col 9 / span 2;
    grid-row: row 12;
  }
  .hero-play-button {
    cursor: pointer;
    z-index: 105;
    grid-column: col 15 / span 1;
    grid-row: row 13;
    height: 181px;
    width: 181px;
  }

  /* Hack to prevent wistia from creating hard width overscroll behavior -JT 6-2-2020 */
  :global(.more-img .wistia_click_to_play) {
    width: auto !important;
  }
  @media (min-width: 685px) and (max-width: 1230px) {
    .more-img {
      grid-column: col 8 / span 2;
      grid-row: row 7;
      margin-left: 28px;
    }
  }
  @media only screen and (max-width: 1024px) {
    .hero-play-button {
      grid-column: col 15 / span 1;
      grid-row: row 15;
    }
  }
  @media (min-width: 0px) and (max-width: 685px) {
    .more-img {
      grid-column: col;
      grid-row: row 32;
      margin-left: auto;
      margin-right: auto;
      width: 185px;
    }
  }
  @media only screen and (max-width: 640px) {
    .hero-play-button {
      grid-column: col 15 / span 1;
      grid-row: row 3;
    }
  }
  @media only screen and (max-width: 400px) {
    .hero-play-button {
      z-index: 205;
      width: 165px;
    }
  }
  @media only screen and (max-width: 360px) {
    .more-img {
      grid-row: row 31;
    }
  }
</style>

<div class={className}>
  <div
    class={`wistia_embed wistia_async_${wistiaSlug} popover=true popoverContent=link u-pointer`}>
    <slot />
  </div>
</div>
